import React from 'react';
import PropTypes from 'prop-types';
import { View } from '../View';

import { styleUtils } from '../../utils';

import styles from './styles';

const { style } = styleUtils;

const Container = style(View, styles.container);

const Section = ({ width, height, children }) => (
  <Container width={width} height={height}>
    {children}
  </Container>
);

Section.propTypes = {
  children: PropTypes.any.isRequired,
  width: PropTypes.string,
  height: PropTypes.string
};

Section.defaultProps = {
  width: '675px'
};

export default Section;
